<div
  class="operation-inner"
  *ngFor="let operation of operationsFormArray.controls; let index = index; trackBy: trackByIndex"
>
  <y42-operation-input-text-form-group
    class="contents"
    [form]="operation"
    [index]="index"
    [columnType]="columnType"
    [predefinedValues]="predefinedValues"
    [enableMoreConditions]="enableMoreConditions"
    [operatorOptions]="operatorOptions"
    (loadAutoProposal)="loadAutoProposal.emit()"
  ></y42-operation-input-text-form-group>
</div>
